import { heroCategories, updateList } from '@/mocks/haijiao';

function UpdateStrip() {
  const doubled = [...updateList, ...updateList];
  return (
    <div className="overflow-hidden border-b border-stone-200 bg-[#fff7ed]">
      <div className="mx-auto flex max-w-[1240px] items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 text-sm font-semibold text-orange-700">
          <i className="ri-flashlight-line"></i>
          <span className="whitespace-nowrap">广场快讯</span>
        </span>
        <div className="relative min-w-0 flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-10">
            {doubled.map((u, i) => (
              <span key={i} className="flex shrink-0 items-center gap-2 text-sm text-stone-600">
                {u.hot && <i className="ri-fire-line text-orange-600"></i>}
                <span className="whitespace-nowrap">{u.text}</span>
              </span>
            ))}
          </div>
        </div>
        <a href="#feed" className="hidden shrink-0 whitespace-nowrap text-sm font-medium text-orange-700 sm:block">
          去广场看看 <i className="ri-arrow-right-s-line align-middle"></i>
        </a>
      </div>
    </div>
  );
}

export default function Hero() {
  return (
    <section id="top" className="border-b border-stone-200/80 bg-[#fdfaf6]">
      <UpdateStrip />

      <div className="mx-auto grid max-w-[1240px] gap-10 px-4 py-10 md:grid-cols-[1.15fr_0.85fr] md:px-6 md:py-14">
        <div className="flex flex-col items-start">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-orange-200 bg-orange-100 px-3 py-1 text-xs font-medium text-orange-700">
            <i className="ri-community-line"></i> 海角社区 · 热门板块今日话题讨论区
          </span>
          <h1 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-stone-900 md:text-5xl">
            这里汇聚海角社区的
            <span className="text-orange-600">热门板块</span>与今日话题
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-stone-600 md:text-base">
            从社区广场到帖子讨论，再到分类圈子，海角社区的内容分类一目了然。帮你快速摸清板块节奏，找到想聊的话题，吃瓜冲浪不再找不到方向。
          </p>

          <div className="mt-6 flex w-full max-w-xl flex-col gap-2 sm:flex-row">
            <div className="flex flex-1 items-center gap-2 rounded-full border border-stone-300 bg-white px-4 py-2.5">
              <i className="ri-search-line text-stone-400"></i>
              <input
                className="w-full bg-transparent text-sm text-stone-700 outline-none placeholder:text-stone-400"
                placeholder="搜热门板块、圈子或话题"
                aria-label="搜索板块与话题"
              />
            </div>
            <a
              href="#boards"
              className="whitespace-nowrap rounded-full bg-orange-600 px-6 py-2.5 text-center text-sm font-semibold text-white transition-colors hover:bg-orange-700"
            >
              浏览热门板块
            </a>
          </div>

          <div className="mt-4 flex flex-wrap gap-2">
            {heroCategories.map((c, i) => (
              <a
                key={c}
                href="#feed"
                className={
                  i === 0
                    ? 'whitespace-nowrap rounded-full bg-stone-900 px-3 py-1.5 text-xs font-medium text-white'
                    : 'whitespace-nowrap rounded-full border border-stone-300 bg-white px-3 py-1.5 text-xs text-stone-600 transition-colors hover:border-orange-400 hover:text-orange-700'
                }
              >
                {c}
              </a>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-4">
            <div>
              <p className="text-2xl font-bold text-stone-900">16,000+</p>
              <p className="text-xs text-stone-500">广场在线讨论</p>
            </div>
            <div className="h-8 w-px bg-stone-200"></div>
            <div>
              <p className="text-2xl font-bold text-stone-900">230</p>
              <p className="text-xs text-stone-500">活跃板块圈子</p>
            </div>
            <div className="h-8 w-px bg-stone-200"></div>
            <div>
              <p className="text-2xl font-bold text-stone-900">320万</p>
              <p className="text-xs text-stone-500">累计今日话题</p>
            </div>
          </div>
        </div>

        <div className="hidden flex-col gap-4 md:flex">
          <div className="rounded-2xl border border-stone-200 bg-white p-5">
            <div className="flex items-center justify-between">
              <p className="text-sm font-bold text-stone-900">广场实时滚动</p>
              <span className="flex items-center gap-1 rounded-full bg-orange-100 px-2 py-0.5 text-xs text-orange-700">
                <span className="h-1.5 w-1.5 rounded-full bg-orange-500"></span> 热播中
              </span>
            </div>
            <div className="mt-4 space-y-3">
              {updateList.slice(0, 5).map((u, i) => (
                <a
                  href="#feed"
                  key={i}
                  className="flex items-start gap-3 rounded-xl border border-stone-100 bg-orange-50/50 p-3 transition-colors hover:bg-orange-100/60"
                >
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-orange-600 text-[11px] font-bold text-white">
                    {i + 1}
                  </span>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-medium text-stone-800">{u.text}</p>
                    <p className="mt-1 text-xs text-stone-400">广场快讯 · 刚刚更新</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}